import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { backend } from "../../components/apipath";
import { useAuth } from "../login/AuthProvider";
import { motion } from "framer-motion";

function ReferralForm() {
  const { authorized } = useAuth();

  const [form, setForm] = useState({
    referrer_name: "",
    contact_phone: "",
    has_purchased: "", // "1" or "0"
    buyer_name: "", // ✅ 新增：新朋友中文姓名
    purchase_items: [], // ✅ 新增：預計購買項目（多選）
    bank_name: "",
    bank_branch: "",
    bank_account: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ checkbox 多選
  const handlePurchaseItemChange = (e) => {
    const { value, checked } = e.target;

    setForm((prev) => {
      const next = new Set(prev.purchase_items);
      if (checked) next.add(value);
      else next.delete(value);
      return { ...prev, purchase_items: Array.from(next) };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ 必填欄位你可依需求調整
    if (
      !form.referrer_name ||
      !form.contact_phone ||
      !form.buyer_name ||
      form.purchase_items.length === 0 ||
      !form.bank_branch ||
      !form.bank_account ||
      !form.address
    ) {
      Swal.fire("提醒", "請先填寫所有必填欄位。", "warning");
      return;
    }

    try {
      await axios.post(
        `${backend}referral/create`,
        {
          ...form,
          has_purchased: form.has_purchased === "1" ? 1 : 0,
          // ✅ 建議存成字串：CPA,EA
          purchase_items: form.purchase_items.join(","),
        },
        { withCredentials: true }
      );

      Swal.fire("已送出", "感謝您填寫推薦登記表，我們會儘快為您處理。", "success");

      setForm({
        referrer_name: "",
        contact_phone: "",
        has_purchased: "",
        buyer_name: "",
        purchase_items: [],
        bank_name: "",
        bank_branch: "",
        bank_account: "",
        address: "",
      });
    } catch (err) {
      console.error(err);
      Swal.fire("送出失敗", "系統忙碌中，請稍後再試。", "error");
    }
  };

  return (
    <>
      {/* banner */}
      <div className="banner mb-5">
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{
            delay: 0.4,
            default: { ease: "linear" },
          }}
        >
          <img src="../memberImg/recommend2.png" alt="" />
        </motion.div>
      </div>

      <div className="container py-4">
        <h2>Becker 學員推薦優惠活動 - 推薦登記表</h2>

        <form onSubmit={handleSubmit} className="mt-3">
          {/* 學員（老朋友）中文姓名 */}
          <div className="mb-3">
            <label className="form-label">
              學員（老朋友）中文姓名 <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="referrer_name"
              className="form-control"
              value={form.referrer_name}
              onChange={handleChange}
              required
            />
          </div>

          {/* 連絡電話 */}
          <div className="mb-3">
            <label className="form-label">
              您的連絡電話 <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="contact_phone"
              className="form-control"
              value={form.contact_phone}
              onChange={handleChange}
              required
            />
          </div>

          <p className="small text-muted">
            未來每當新朋友完成購買，您的推薦成立、獲得推薦回饋金，我們將主動以匯款方式支付回饋金至您的銀行收款帳號，並通知您。
          </p>

          {/* ✅ 新增：新朋友中文姓名 */}
          <div className="mb-3">
            <label className="form-label">
              您推薦的購買人（新朋友）中文姓名 <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="buyer_name"
              className="form-control"
              value={form.buyer_name}
              onChange={handleChange}
              required
            />
          </div>

          {/* ✅ 新增：預計購買項目（多選） */}
          <div className="mb-3">
            <label className="form-label">
              購買人（新朋友）預計購買項目 <span className="text-danger">*</span>
            </label>

            <div className="d-flex gap-4 mt-2">
              <label className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  value="CPA"
                  checked={form.purchase_items.includes("CPA")}
                  onChange={handlePurchaseItemChange}
                />
                <span>CPA</span>
              </label>

              <label className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  value="EA"
                  checked={form.purchase_items.includes("EA")}
                  onChange={handlePurchaseItemChange}
                />
                <span>EA</span>
              </label>
            </div>

            <div className="form-text">可複選（例如同時選 CPA + EA）。</div>
          </div>

          {/* 銀行資料 */}
          <div className="mb-3">
            <label className="form-label">請提供您本人的收款銀行名稱（例如：台新銀行）</label>
            <input
              type="text"
              name="bank_name"
              className="form-control"
              value={form.bank_name}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              承上題，收款銀行分行名稱（例如：信維分行）
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="bank_branch"
              className="form-control"
              value={form.bank_branch}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              承上題，收款銀行帳號（例如：xxxx-xxx-xxx-x）
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="bank_account"
              className="form-control"
              value={form.bank_account}
              onChange={handleChange}
              required
            />
          </div>

          {/* 地址 */}
          <div className="mb-3">
            <label className="form-label">
              您的地址 <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="address"
              className="form-control"
              value={form.address}
              onChange={handleChange}
              required
            />
            <div className="form-text">依照國稅局規定，為申報超過 1,000 元之所得扣繳用。</div>
          </div>

          <button type="submit" className="btn btn-primary mb-5">
            送出
          </button>
        </form>
      </div>
    </>
  );
}

export default ReferralForm;
